/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/interception': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M16 2H4L2 4v11l2 3h12l2-3V4l-2-2zM4 5h1V4h1v1h1v1H6v1H5V6H4V5zm3 10H6v1H5v-1H4v-1h1v-1h1v1h1v1zm3-2a3 3 0 110-6 3 3 0 010 6zm6 2h-1v1h-1v-1h-1v-1h1v-1h1v1h1v1zm0-9h-1v1h-1V6h-1V5h1V4h1v1h1v1z"/>'
  }
})
